"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveTableInfo = exports.getTableFormatInfo = void 0;
var metadata_1 = require("../metadata/metadata");
var definitionCreators_1 = require("../metadata/definitionCreators");
var NullStringDefinition = (0, definitionCreators_1.createStringDefinition)(false /** isOptional */, undefined /** value */, true /** allowNull */);
var BooleanDefinition = (0, definitionCreators_1.createBooleanDefinition)(false /** isOptional */);
var TableFormatMetadata = (0, definitionCreators_1.createObjectDefinition)({
    topBorderColor: NullStringDefinition,
    bottomBorderColor: NullStringDefinition,
    verticalBorderColor: NullStringDefinition,
    hasHeaderRow: BooleanDefinition,
    headerRowColor: NullStringDefinition,
    hasFirstColumn: BooleanDefinition,
    hasBandedColumns: BooleanDefinition,
    hasBandedRows: BooleanDefinition,
    bgColorEven: NullStringDefinition,
    bgColorOdd: NullStringDefinition,
    tableBorderFormat: (0, definitionCreators_1.createNumberDefinition)(false /** isOptional */, undefined /* value */, 0 /* DEFAULT */, 8 /* CLEAR */),
    keepCellShade: (0, definitionCreators_1.createBooleanDefinition)(true /** isOptional */),
}, false /* isOptional */, true /** allowNull */);
/**
 * Get the format info of a table
 * If the table does not have a info saved, it will be retrieved from the css styles
 * @param table The table that has the info
 */
function getTableFormatInfo(table) {
    return (0, metadata_1.getMetadata)(table, TableFormatMetadata);
}
exports.getTableFormatInfo = getTableFormatInfo;
/**
 * @internal
 * Save the format info of a table
 * @param table The table the info will be saved
 * @param format The format of the table
 */
function saveTableInfo(table, format) {
    if (table && format) {
        (0, metadata_1.setMetadata)(table, format, TableFormatMetadata);
    }
}
exports.saveTableInfo = saveTableInfo;
//# sourceMappingURL=tableFormatInfo.js.map